import Cookies from "js-cookie";

const getUserID = () => {
  return localStorage.getItem("userID");
};

const getActivePlan = () => {
  return localStorage.getItem("activePlan");
};


const getUserEmail = () => {
  return localStorage.getItem("userEmail");
};

const getUserRole = () => {
  return localStorage.getItem("role");
};

const getUserToken = () => {
  return localStorage.getItem("userToken");
};

const isLoggedIn = () => {
  const userID = localStorage.getItem("userID");
  // const guestId = localStorage.getItem("guestId");
  const isPublic = localStorage.getItem("isPublic") === "true";
  const currentPath = window.location.pathname;

  if (currentPath.startsWith("/agents/asst_") && isPublic) {
    return true; 
  }
  else {
    return userID || false;
  }
 };

const clearAllCookies = ()=>{
  const allCookies = Cookies.get();
  for (const cookieName in allCookies) {
    Cookies.remove(cookieName);
  }
}
const logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  clearAllCookies();
};

const getUserTeamID = () => {
  return localStorage.getItem("userTeamId");
};

const getUserTeamAccessStatus = () => {
  const checkAccess = localStorage.getItem("userTeamAccess");
  console.log("🚀 ~ getUserTeamAccessStatus ~ checkAccess:", checkAccess);
  return checkAccess === "true" ? true : false;
};

const getCompId = () => {
  return localStorage.getItem("compId");
};

const getUserSelectedTheme = () => {
  return localStorage.getItem("theme") || 'light';
};

const logoutUserAndRedirect = () => {
  localStorage.clear();
  setTimeout(() => {
    window.location.href = "/login";
  }, 700);
};

export {
  getActivePlan,
  getUserID,
  getUserEmail,
  getUserToken,
  getUserRole,
  isLoggedIn,
  logout,
  getUserTeamID,
  getUserTeamAccessStatus,
  getCompId,
  getUserSelectedTheme,
  logoutUserAndRedirect,
};
